import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/Main'
import News from '@/views/News'
// import Round from '@/views/Round'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      meta: {
        title: 'F8th - Account Behavioural Biometry',
        description: 'Protects passively and continuously against account and session takeovers, web bots and insider threats.',
        'og:description': 'Protects passively and continuously against account and session takeovers, web bots and insider threats.'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta: {
        title: 'F8th - News',
        description: 'F8th Inc. last news and updates.',
        'og:description': 'F8th Inc. last news and updates.'
      }
    },
    /*{
      path: '/round',
      name: 'round',
      component: Round,
      meta: {
        title: 'F8th - Seed Round',
        description: 'F8th Inc. seed round information web page.',
        'og:description': 'F8th Inc. seed round information web page.'
      }
    },*/
    {
      path: '*',
      name: '404',
      redirect: '/'
    }
  ]
})